<template>
  <div class="text-center">
    <v-dialog v-model="show" width="500" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Deletar Aluno
        </v-card-title>

        <v-card-text class="mt-3">
          Tem certeza que deseja deletar esta sondagem? <br />
          <div class="d-flex align-center my-2">
            <p class="my-0 mr-1">Nome do aluno:</p>
            <strong v-if="item">{{ item.nomeAluno }}</strong>
          </div>
          Essa ação não pode ser desfeita.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="grey" dark @click="fechar()">
            Fechar
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="red" dark @click="deletar(item)">
            Deletar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SondagemInfantilService from "@/service/SondagemInfantilService";

export default {
  name: "DeletarAluno",
  props: {
    item: Object,
    show: Boolean,
  },

  data() {
    return {};
  },

  methods: {
    async deletar(item) {
      try {
        await SondagemInfantilService.deletarAluno(item.id);
        this.$emit("fechar");
      } catch (error) {
        console.error(error);
      }
    },

    fechar() {
      this.$emit("fechar");
    }
  },
};
</script>

<style scoped></style>
